/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Link, InputLabel, InputAdornment } from "@mui/material";

export const PageContainer = styled('div')({
  width: '100%',
  overflowX: 'hidden',
})

export const StyledBreadCrumbContainer = styled('div')({
  height: '20px',
  width: '100%',
  backgroundColor: '#f5f5f8',
  padding: '10px 0px 10px 20px',
  borderColor: '#e0e0e0',
  borderWidth: '0px 0px 1px 0px',
  borderStyle: 'solid',
})

export const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'color',
})(({ color }) => ({
  textDecoration: 'none',
  color: color,
  fontSize: '13px',
  fontWeight: '400',
}));

export const viewTextStyles = {
  color: "#666",
  fontSize: "0.875rem",
  alignSelf: { xs: "flex-start", sm: "center" },
  whiteSpace: "nowrap",
  mt: 0,
}

export const StyledInputLabel = styled(InputLabel)({
  fontSize: '14px',
})

export const StyledFilterCancel = styled(InputAdornment)({
  position: 'absolute',
  right: 25,
})

export const datePickerStyles = {
  "&:hover fieldset":{
    borderColor: '#2b4fb9 !important'
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#2b4fb9',
    },
  },
  ".MuiInputBase-root": {
    height: "2.4rem",
    backgroundColor: "white",
    fontSize: "14px",
  },
  "& input::placeholder": {
    color: "black",
  },
  width: { xs: "100%", sm: "160px" },
}
